import React, { useMemo } from 'react';

import { graphql } from 'gatsby';
import { getSrc } from '../../utils/media';
import GridSectionDS from 'design-system/src/components/organisms/GridSection';

export default function GridInfo3Section({ items, ...props }: any) {
    const formattedItems = useMemo(() => {
        if (!items || !items.length) {
            return [];
        }

        return items.map((item) => {
            return {
                title: item?.title,
                text: item?.description,
                icon: getSrc(item?.icon),
            };
        });
    }, [items]);
    return (
        <GridSectionDS
            {...props}
            variant="grid-info-3"
            items={formattedItems}
        />
    );
}

export const query = graphql`
    fragment DatoCmsGridInfo3Section on DatoCmsGridInfo3Section {
        title
        titleTag
        items {
            ...Point
        }
    }
`;
